import { Space, Typography } from 'antd'
import { EJReportType, Report } from '@cims-online/shared'
import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { EngineeringJudgement } from '../../../../../EJLogContext/types'
import CIMSLink from 'components/CIMSLink'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import { HelpMessage } from 'utils/constants'
import { getReportName } from '../utils'

export function useReportsColumn(): CIMSSingleColumn<EngineeringJudgement> {
  const deps = useReportURLDependencies()
  return {
    title: 'Reports',
    render: ({ manualReportId, ejToReports }) => {
      if (manualReportId)
        return <Typography.Text>{manualReportId}</Typography.Text>
      const reports = ejToReports.map(
        ({
          reportId: globalId,
          reportTypeId,
          concretePlacement,
          concreteTest,
          lot,
          dailyInspectionControlPoint,
          dailyInspectionInspection,
        }) => {
          let url
          if (reportTypeId === EJReportType.ConcreteTest.id)
            url = Report.ConcreteCylinderIASheet.toURL({
              globalId,
              ...deps,
            })
          else if (reportTypeId === EJReportType.ConcretePlacement.id)
            url = Report.ConcretePlacementCoreSheet.toURL({
              globalId,
              ...deps,
            })
          else if (reportTypeId === EJReportType.DensityLot.id)
            url = Report.DensityLot.toURL({ globalId, ...deps })
          else if (reportTypeId === EJReportType.DailyInspectionInspection.id)
            url = Report.Inspection.toURL({
              globalId,
              ...deps,
            })
          else if (reportTypeId === EJReportType.DailyInspectionControlPoint.id)
            url = Report.ControlPoint.toURL({
              globalId,
              ...deps,
            })
          return {
            reportName: getReportName({
              concretePlacement,
              concreteTest,
              lot,
              dailyInspectionControlPoint,
              dailyInspectionInspection,
            }),
            url,
          }
        }
      )
      return (
        <Space size="small" direction="vertical">
          {reports.map(({ reportName, url }) => (
            <CIMSLink external href={url}>
              {reportName}
            </CIMSLink>
          ))}
        </Space>
      )
    },
    width: 150,
    help: HelpMessage.EngineeringJudgements.EJLog.Reports,
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { ejToReports }) =>
        ejToReports.some(({ reportId }) =>
          reportId.toLowerCase().includes(value.toString().toLowerCase())
        ),
    },
  }
}
